import SDK, { CreditCardForm } from "@d24/sdk";
import "./styles.css";
import getValidLocale from "./helpers/getValidLocale";

/**
 * agregar los necesarios query params:
 * Ejemplo:
 * http://localhost:3000/?country=PE&auth-token=2NROUtadDbLT67UFZlvTCO9QOJhSyHhF&locale=es
 */

/**
 * query params:
 * country    -> countryCode -> PE
 * auth-token -> authToken   -> string
 * locale                    -> en|es|pt
 */

const urlParams = new URLSearchParams(window.location.search);
const countryCode = urlParams.get('country') || undefined;
const authToken = urlParams.get('auth-token') || undefined;
const locale = getValidLocale(urlParams.get('locale'))
const SDKPublicKey = process.env[`REACT_APP_D24_PUBLIC_KEY_${countryCode}`]


const d24SDK = new SDK(SDKPublicKey, {
  environment: process.env.REACT_APP_D24_ENV, // stg | prod
  locale
});

function handleTokenErrorCallback(error) {
  console.log('error', error);
}

function handleGoBackCallback() {
  console.log('Go back');
}

export default function App() {
  return (
    <CreditCardForm
      authToken={authToken}
      country={countryCode}
      onTokenGenerationError={handleTokenErrorCallback}
      onBack={handleGoBackCallback}
    />
  );
}
